/**
 * One style for every control on the composer's toolbar row.
 *
 * The row mixes three sources — the formatting tools, the default-factiii
 * buttons, and the composer's own media/drafts buttons — and they used to
 * disagree on box size, radius, hover and what "active" looks like. They all go
 * through here now, so the row reads as one toolbar and cannot drift again.
 *
 * Sized to fit: sixteen controls plus Post do not fit the ~674px composer at
 * 36px, so the whole row is 32px with a 22px glyph.
 */
export const TOOLBAR_ICON = 22;

const BASE =
  'flex size-8 shrink-0 items-center justify-center rounded-md transition-colors duration-200';
const IDLE =
  'text-textSecondary hover:bg-background-light hover:text-textPrimary';
const ACTIVE = 'bg-background-light text-primary';

/** `active` lights the control the way a pressed toggle should look. */
export const toolbarButton = (active = false): string =>
  `${BASE} ${active ? ACTIVE : IDLE}`;
